import request from '../api/request';
import ppt from './module/ppt';
import tts from './module/tts';
import tcts from './module/tcts';
import intelligence from './module/intelligence';
import { createStore } from 'vuex';
import config from '@/api/config';
const initQuery = {
    // 对话内容
    keyword: '',
    link: [],
    type: '',
    modelId: '',
    translateType: '',
    writeQuery: {},
    isDeep: false,
    is_create: false,
    images: [],
    model: '',
    fileAnalyseUrl: [],
    fileListJson: ''
};
export default createStore({
    state: {
        chatQuery: JSON.parse(JSON.stringify(initQuery)), // 对话内容
        histroyIndex: 1, // 历史导航下标
        histroyList: [], // 历史消息
        drawHistroyList: [], // 绘画历史消息
        simpleList: [], // 智能体
        isCollapse: false, // 侧边栏状态
        loginStatus: false, //登录弹窗是否开启
        userInfo: {}, // 用户信息
        token: '', // token
        histroyOther: {
            // 历史记录相关
            status: false // 清空历史状态
        },
        intelligenceStatus: false, // 智能体是否对话中
        voicecallStatus: false, // 语音是否对话中
        imagecomprehendCreate: {
            image: [],
            keyword: ''
        },
        // 当前对话是否正在进行中
        chatStatus: '', // chat/对话 imagecomprehend/图片理解 translate/翻译 tabulation/AI表格 nineHeavens/九天 deepseek drawing/AI绘画
        // 侧边栏跳转路由
        sidebarJump: '',
        // 侧边栏历史记录被选择数据
        histroySelect: {},
        // 网络状态
        lineStatus: true,
        // 模型列表
        modelList: {
            list: [],
            key: ''
        },
        // 是否移动端
        isMobile: false,
        // 判断是否pad端
        isPad: false,
        // 软键盘高度
        keyboardHeight: 0,
        // 是否竖屏
        isPortrait: false,
        // 是否小iPad
        isSmallIpad: false,
    },
    getters: {
        getModelInfo(state) {
            return state.modelList.list.find(item => item.id == state.modelList.key);
        }
    },
    mutations: {
        // 设置是否移动端
        setIsMobile(state, playload) {
            state.isMobile = playload || false;
        },
        // 设置是否小iPad
        setIsSmallIpad(state, playload) {
            state.isSmallIpad = playload || false;
        },
        // 存储token
        setToken(state, playload) {
            state.token = playload || '';
        },
        // 存储对话内容
        setChat(state, playload) {
            Object.keys(playload).forEach(key => {
                if (state.chatQuery.hasOwnProperty(key)) {
                    state.chatQuery[key] = playload[key];
                }
            });
        },
        // 初始化
        initChat(state, playload) {
            state.chatQuery = JSON.parse(JSON.stringify(initQuery)); // 对话内容
            state.chatQuery.is_create = false;
            state.chatQuery.isDeep = false;
        },
        // 操作侧边栏
        handleCollapse(state, playload) {
            state.isCollapse = playload || false;
        },
        // 获取历史消息
        async setHistroyList(state, playload) {
            try {
                const res = await request.post('/app-api/lt/ai/chat/conversation/unionList', {
                    pageNo: 1,
                    pageSize: 20
                });
                state.histroyList = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? JSON.parse(JSON.stringify(res.data)) : [];
            }
            catch (error) { }
        },
        // 获取绘画历史消息
        async setDrawHistroyList(state, playload) {
            var _a;
            try {
                const res = await request.post('/app-api/lt/ai/image/getSessionList', {});
                state.drawHistroyList = Array.isArray((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.list) ? JSON.parse(JSON.stringify(res.data.list)) : [];
            }
            catch (error) { }
        },
        // 存储智能体列表
        async setSimpleList(state, playload) {
            try {
                const res = await request.get('/app-api/lt/ai/chat/model/simple-list', {
                    status: 0
                });
                state.simpleList = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? JSON.parse(JSON.stringify(res.data)) : [];
            }
            catch (error) { }
        },
        // 存储登录状态
        setLoginStatus(state, playload) {
            state.loginStatus = (playload === null || playload === void 0 ? void 0 : playload.status) || false;
        },
        // 存储用户信息
        setUserInfo(state, playload) {
            state.userInfo = playload || {};
        },
        // 历史状态相关
        setHistroyOther(state, playload) {
            typeof playload === 'object' &&
                Object.keys(playload).forEach(key => {
                    if (key in state.histroyOther) {
                        state.histroyOther[key] = playload[key];
                    }
                });
        },
        // 存储历史选择导航
        setHistroyIndex(state, playload) {
            state.histroyIndex = playload || 0;
        },
        // 智能体状态
        setIntelligenceStatus(state, playload) {
            state.intelligenceStatus = playload || false;
        },
        // 语音状态
        setVoicecallStatus(state, playload) {
            state.voicecallStatus = playload || false;
        },
        // 存储图片理解创建信息
        setImagecomprehendCreate(state, playload) {
            state.imagecomprehendCreate = playload || {};
        },
        // 存储当前对话状态
        setChatStatus(state, playload) {
            state.chatStatus = playload || '';
        },
        // 存储侧边栏历史被点击数据
        setHistroySelect(state, playload) {
            state.histroySelect = playload || {};
        },
        // 存储侧边栏跳转路由
        setSidebarJump(state, playload) {
            state.sidebarJump = playload || '';
        },
        // 网络状态
        setLineStatus(state, playload) {
            state.lineStatus = navigator.onLine || false;
        },
        // 存储模型列表key
        setModelListKey(state, playload) {
            var _a;
            let findIndex = state.modelList.list.findIndex(item => (item === null || item === void 0 ? void 0 : item.id) == playload);
            state.modelList.key = findIndex !== -1 ? playload : (_a = state.modelList.list[0]) === null || _a === void 0 ? void 0 : _a.id;
            localStorage.setItem('modelListKey', state.modelList.key || '');
        },
        // 设置是否pad端
        setIsPad(state, playload) {
            state.isPad = playload || false;
        },
        // 设置软键盘高度
        setKeyboard(state, playload) {
            state.keyboardHeight = playload || 0;
        },
        // 设置是否竖屏
        setIsPortrait(state, playload) {
            state.isPortrait = playload || false;
        },
    },
    actions: {
        // 获取用户信息
        getUserInfo(state, playload) {
            return new Promise((resolve, reject) => {
                request
                    .get('/app-api/member/user/get', {})
                    .then(res => {
                    state.commit('setUserInfo', res === null || res === void 0 ? void 0 : res.data);
                    state.dispatch('getVesion');
                    state.dispatch('getModelList');
                    resolve(res);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        },
        // 获取版本信息
        async getVesion(state, playload) {
            var _a, _b, _c, _d;
            // 获取版本信息
            try {
                const versionRes = await request.get('/app-api/app-api/ai/apk-version/get-latest', {});
                if ((_a = versionRes === null || versionRes === void 0 ? void 0 : versionRes.data) === null || _a === void 0 ? void 0 : _a.privacyPolicyUrl) {
                    config.privacyURL = (_b = versionRes === null || versionRes === void 0 ? void 0 : versionRes.data) === null || _b === void 0 ? void 0 : _b.privacyPolicyUrl;
                }
                if ((_c = versionRes === null || versionRes === void 0 ? void 0 : versionRes.data) === null || _c === void 0 ? void 0 : _c.userAgreementUrl) {
                    config.employURL = (_d = versionRes === null || versionRes === void 0 ? void 0 : versionRes.data) === null || _d === void 0 ? void 0 : _d.userAgreementUrl;
                }
            }
            catch (error) { }
        },
        // 获取通用模型列表
        async getModelList(state, playload) {
            var _a, _b;
            try {
                const res = await request.get('/app-api/lt/ai/chat/model/getModelTypeList', { modelType: 8 });
                state.state.modelList.list = [];
                if (Array.isArray(res === null || res === void 0 ? void 0 : res.data)) {
                    res.data.forEach((el) => {
                        var _a, _b, _c;
                        if (((_a = el === null || el === void 0 ? void 0 : el.name) === null || _a === void 0 ? void 0 : _a.indexOf('灵犀')) == -1 && ((_b = el === null || el === void 0 ? void 0 : el.name) === null || _b === void 0 ? void 0 : _b.indexOf('混元')) == -1 && ((_c = el === null || el === void 0 ? void 0 : el.name) === null || _c === void 0 ? void 0 : _c.indexOf('豆包')) == -1) {
                            state.state.modelList.list.push(el);
                        }
                    });
                    let doubaoFind = res.data.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a.indexOf('豆包联网')) !== -1; });
                    if (doubaoFind === null || doubaoFind === void 0 ? void 0 : doubaoFind.id) {
                        doubaoFind.name = '灵犀';
                        doubaoFind.isDeep = true;
                        state.state.modelList.list.unshift(doubaoFind);
                    }
                }
                state.commit('setModelListKey', ((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) || '');
            }
            catch (error) { }
        },
    },
    modules: {
        ppt,
        tts,
        tcts,
        intelligence
    }
});
